import { render, staticRenderFns } from "./ShapeDiagonalBottomLeft.vue?vue&type=template&id=5f64e9a8&scoped=true&"
import script from "./ShapeDiagonalBottomLeft.vue?vue&type=script&lang=ts&"
export * from "./ShapeDiagonalBottomLeft.vue?vue&type=script&lang=ts&"
import style0 from "./ShapeDiagonalBottomLeft.vue?vue&type=style&index=0&id=5f64e9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64e9a8",
  null
  
)

export default component.exports